import React from 'react';
import { FormattedMessage } from 'react-intl';
import { SCHEDULED_PICKUPS_VIEW_ID, SHIPMENT_PICKUPS_VIEW_ID } from './view-id-constants';

export const ScheduledPickups = {
  label: <FormattedMessage defaultMessage='Carrier Pickups' description='shippingPage.nav.scheduled-pickup' id='UKfNr1' />,
  id: SCHEDULED_PICKUPS_VIEW_ID,
  navigationOverride: `/shipments/${SHIPMENT_PICKUPS_VIEW_ID}`,
};
